import { BannerRepository } from '../../domain/repositories/banner.repository';
import { BannerEntity } from '../../domain/entities/banner.entity';

export class ToggleBannerStatusUseCase {
  constructor(private readonly bannerRepository: BannerRepository) {}

  async execute(id: string): Promise<BannerEntity> {
    return this.bannerRepository.toggleBannerStatus(id);
  }
}
